import styled from 'styled-components';

export const Column = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`;

export const SettingsArea = styled.div`
    display: flex;
    justify-content: center;
    align-items: flex-start;

    .container {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 10px 0px;
    }
`;

export const ParameterArea = styled.div`
    width: 100%;
    border: 1px solid #ddd;
    padding: 10px;
`;
